import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';

export interface Slice {
  copilotTextarea: string;
  replacementText: string;
}

const initialState: Slice = { copilotTextarea: '', replacementText: '' };

const slice = createSlice({
  name: 'copilotTextarea',
  initialState,
  reducers: {
    setCopilotTextarea: (state: Slice, action: PayloadAction<string>) => {
      state.copilotTextarea = action.payload;
    },
    setReplacementText: (state: Slice, action: PayloadAction<string>) => {
      state.replacementText = action.payload;
    },
  },
});

export const selectCopilotTextarea = createSelector(
  (state: { copilotTextarea: Slice }) => state.copilotTextarea,
  (state) => state.copilotTextarea
);

export const selectReplacementText = createSelector(
  (state: { copilotTextarea: Slice }) => state.copilotTextarea,
  (state) => state.replacementText
);

export default slice;
